import { Dialog } from "@mui/material";
import React from "react";
import { Button } from "../ui";
import InlineLoader from "../loader/InlineLoader";

const ConfirmationModal = ({
  isOpen,
  onClose,
  title,
  description,
  confirmButtonLabel,
  onConfirm,
  isLoading = false,
  loadingMessage = "Loading...",
  showReasonField = false,
  reason = "",
  onReasonChange,
  reasonPlaceholder = "Enter reason...",
  reasonLabel = "Reason",
}) => {
  const handleClose = () => {
    if (!isLoading) {
      onClose();
    }
  };

  return (
    <Dialog 
      open={isOpen} 
      onClose={handleClose}
      disableEscapeKeyDown={isLoading}
      onBackdropClick={!isLoading ? handleClose : undefined}
      maxWidth="sm" 
      fullWidth
    >
      <div className="p-4">
        <h2 className="font-semibold text-xl">{title}</h2>
        <p className="text-neutral mt-3">{description}</p>
        
        {showReasonField && (
          <div className="mt-4 space-y-2">
            <label className="text-sm font-medium text-gray-700">{reasonLabel}</label>
            <textarea
              value={reason}
              onChange={(e) => onReasonChange?.(e.target.value)}
              placeholder={reasonPlaceholder}
              className="w-full min-h-[80px] border border-gray-300 rounded-lg p-2 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500 resize-none"
            />
          </div>
        )}
        
        <div className="flex items-center justify-center space-x-5 mt-4">
          <Button
            className=""
            label={"Cancel"}
            variant="outline"
            onClick={handleClose}
            disabled={isLoading}
          >
            Cancel
          </Button>
          <Button
            className=""
            label={isLoading ? loadingMessage : confirmButtonLabel}
            variant="default"
            onClick={onConfirm}
            disabled={(showReasonField && !reason.trim()) || isLoading}
          >
            {isLoading ? (
              <div className="flex items-center justify-center space-x-2">
                <InlineLoader className="text-white" />
                <span>{loadingMessage}</span>
              </div>
            ) : (
              confirmButtonLabel
            )}
          </Button>
        </div>
      </div>
    </Dialog>
  );
};

export default ConfirmationModal;
